import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "BM_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#BM_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#AF0100"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "BM_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#BM_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.03 11.043h8.888v8.99s-.276 1.237-1.987 2.055c-1.711.817-2.457.817-2.457.817s-2.726-.67-3.29-1.297c-.563-.627-1.155-.859-1.155-1.955v-8.61z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "BM_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 21,
      y: 11,
      width: 9,
      height: 12
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.03 11.043h8.888v8.99s-.276 1.237-1.987 2.055c-1.711.817-2.457.817-2.457.817s-2.726-.67-3.29-1.297c-.563-.627-1.155-.859-1.155-1.955v-8.61z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#BM_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.455 11.57a.49.49 0 00.051-.094l-.003.15c.032.03.07.052.117.052l.197-.117s-.046.258.014.25c0 0 .184-.12.256-.055 0 0-.213.245.044.246 0 0 .324-.052.296.098 0 0-.243.446-.14.474l.4-.012s-.269.234-.262.332l.134.105s.075-.184.138-.034c0 0 .008.275-.034.275l-.356.114s-.023.134.105.134c0 0 .294-.125.303.002 0 0-.04.146-.056.27l-.022.487s.023-.017.247.247c0 0 .566.357.67.275.028-.023.047-.069.068-.121.055-.138.128-.318.44-.221h.003c.43.134.534.166.426.342-.11.176-.523.596-.523.596l-.358 1.438h.768c.231 0 .444.09.485.282.04.192.052.565.052.61l-.003.024c-.007.062-.021.186.162.186 0 0 .367.048.291.074 0 0-.26-.05-.262.18 0 0-.1.029-.052.312 0 0 .202.62.068.492 0 0-.274-.323-.274-.46 0 0-.196.077-.19.28 0 0-.186.247-.18.005 0 0 .314-.596.139-.461 0 0-.228.492-.258.417l-.844-.228-.321 1.415s.085.265.321.265c.086 0 .162-.033.231-.063.122-.054.223-.098.32.063.15.254.218.278.293.278.075 0 .163.098.119.247-.044.148-.24.26-.327.26-.031 0-.023.027-.012.061.018.059.043.138-.117.138-.127 0-.191-.015-.254-.03a.928.928 0 00-.253-.03h-.087c-.217.003-.401.005-.401-.138 0-.14-.167-.262-.315-.371l-.072-.054c-.159-.122-.506-1.498-.506-1.498l-.656-4.133-.02-.954-.02.954-.655 4.133s-.347 1.376-.507 1.498a5.63 5.63 0 01-.071.054c-.148.108-.315.232-.315.37 0 .144-.184.142-.401.14l-.088-.001a.93.93 0 00-.252.03c-.063.015-.127.03-.254.03-.16 0-.135-.079-.117-.137.01-.034.019-.061-.013-.061-.086 0-.283-.113-.326-.261-.044-.15.043-.247.118-.247s.143-.024.294-.278c.097-.162.198-.117.32-.063.069.03.145.063.23.063.236 0 .322-.265.322-.265l-.322-1.415-.844.228c-.03.075-.257-.417-.257-.417-.176-.135.139.46.139.46.005.244-.18-.005-.18-.005.006-.202-.19-.279-.19-.279 0 .137-.275.46-.275.46-.134.127.068-.492.068-.492.049-.283-.051-.313-.051-.313-.002-.229-.262-.179-.262-.179-.077-.026.29-.074.29-.074.184 0 .17-.124.162-.186a4.276 4.276 0 01.05-.634c.04-.192.253-.282.485-.282h.768l-.359-1.438s-.413-.42-.522-.596c-.109-.176-.004-.208.425-.341l.003-.001c.313-.097.385.083.44.22.022.053.04.1.069.122.104.082.67-.275.67-.275.223-.264.246-.247.246-.247a72.107 72.107 0 01-.021-.487c-.017-.124-.056-.27-.056-.27.008-.127.303-.002.303-.002.127 0 .104-.134.104-.134l-.356-.114c-.042 0-.034-.275-.034-.275.064-.15.139.034.139.034l.133-.105c.007-.098-.261-.332-.261-.332l.4.012c.103-.028-.14-.473-.14-.473-.028-.15.296-.099.296-.099.257-.001.043-.246.043-.246.073-.066.257.056.257.056.06.007.014-.251.014-.251l.197.117a.172.172 0 00.116-.052l-.003-.15s.018.046.051.094z",
      fill: "#CF142B"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.222 20l-.328-.321v3.642H30V19.68l-.327.321c.049-.384-.025-.26-.114-.113a.782.782 0 01-.124.174c-.035.028-.043-.084-.05-.194-.007-.097-.014-.193-.04-.188 0 0-.098-.158-.159-.099-.012.012-.021.1-.031.2a1.645 1.645 0 01-.043.281c-.023.063-.093-.061-.093-.061s.004-.467-.068-.537c-.072-.07-.079.537-.079.537s-.11-.45-.22-.42c-.018.006-.028.123-.039.25-.01.123-.02.254-.04.299-.043.091-.14-.549-.14-.549s-.03.525-.127.549c-.017.004-.032-.08-.048-.174-.016-.09-.034-.188-.055-.224-.045-.075-.258.218-.258.218l-.15-.604-.411.334H23.51l-.412-.334-.149.605s-.213-.293-.258-.219a.943.943 0 00-.055.224c-.017.093-.032.178-.048.174-.098-.024-.127-.549-.127-.549s-.098.64-.14.549a1.404 1.404 0 01-.041-.3c-.01-.126-.02-.244-.039-.249-.11-.03-.22.42-.22.42s-.007-.607-.078-.537c-.072.07-.068.537-.068.537s-.07.123-.093.061a1.634 1.634 0 01-.043-.281.79.79 0 00-.031-.2c-.061-.06-.16.099-.16.099-.025-.005-.032.09-.039.188-.008.11-.016.222-.05.194a.78.78 0 01-.125-.174c-.088-.148-.162-.271-.113.113z",
      fill: "#5DC852"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.178 14.94s.043.11 0 .22v-.22zm-2.694-.177c.074.01.14.029.196.044.132.036.212.057.212-.055 0-.082.216.024.514.17.389.19.916.447 1.286.447.322 0 .445-.104.486-.21v.425c0 .076.017.166.033.251.029.155.054.293-.032.293-.134 0-.735.422-.735.909 0 .486.735.886.735.886s-.487 1.712-.913 1.974c-.258.158-.411.028-.492-.04-.052-.045-.073-.063-.073.04 0 .261-.37.63-.81.776-.284.094-.2.166-.106.248.052.045.107.093.107.148 0 .126-.348-.05-.487-.126-.14.076-.486.252-.486.126 0-.055.055-.103.106-.148.095-.082.178-.154-.106-.248-.44-.146-.81-.515-.81-.776 0-.103-.02-.085-.073-.04-.08.068-.234.198-.492.04-.426-.262-.912-1.974-.912-1.974s.734-.4.734-.886c0-.487-.6-.909-.734-.909-.087 0-.061-.137-.033-.293.016-.085.033-.175.033-.25v-.426c.042.106.164.21.486.21.37 0 .898-.258 1.286-.447.299-.146.515-.252.515-.17 0 .112.08.09.211.055.056-.015.123-.033.196-.044.007-.007.015-.01.022-.01l.057.001a.88.88 0 01.057-.002c.008 0 .015.004.022.01zm-2.852.177s-.043.11 0 .22v-.22z",
      fill: "#4ABCE6"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "BM_svg__d",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 22,
      y: 14,
      width: 7,
      height: 8
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.178 14.94s.043.11 0 .22v-.22zm-2.694-.177c.074.01.14.029.196.044.132.036.212.057.212-.055 0-.082.216.024.514.17.389.19.916.447 1.286.447.322 0 .445-.104.486-.21v.425c0 .076.017.166.033.251.029.155.054.293-.032.293-.134 0-.735.422-.735.909 0 .486.735.886.735.886s-.487 1.712-.913 1.974c-.258.158-.411.028-.492-.04-.052-.045-.073-.063-.073.04 0 .261-.37.63-.81.776-.284.094-.2.166-.106.248.052.045.107.093.107.148 0 .126-.348-.05-.487-.126-.14.076-.486.252-.486.126 0-.055.055-.103.106-.148.095-.082.178-.154-.106-.248-.44-.146-.81-.515-.81-.776 0-.103-.02-.085-.073-.04-.08.068-.234.198-.492.04-.426-.262-.912-1.974-.912-1.974s.734-.4.734-.886c0-.487-.6-.909-.734-.909-.087 0-.061-.137-.033-.293.016-.085.033-.175.033-.25v-.426c.042.106.164.21.486.21.37 0 .898-.258 1.286-.447.299-.146.515-.252.515-.17 0 .112.08.09.211.055.056-.015.123-.033.196-.044.007-.007.015-.01.022-.01l.057.001a.88.88 0 01.057-.002c.008 0 .015.004.022.01zm-2.852.177s-.043.11 0 .22v-.22z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#BM_svg__d)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.463 16.893s2.186-.233 3.47-.233c1.284 0 .594.08 1.087.135.494.055.99.098.99.098v4.393h-5.547v-4.393z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.983 16.273s-.178-.35.547-.476c.724-.125.949-.178 1.223.149.275.327.834 1.733.417 2.111-.417.378-.707.776-.872.637-.164-.138.188-.637-.683-.637h-1.17l.538-1.784z",
      fill: "#FFDA3A"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M26.655 16.613l-1.562.479s.141 1.067-.262 1.067-.575-2.31-.575-2.31h-.166l.53 2.54-.364.236 1.117.496 1.892-.962-.61-1.546z",
      fill: "#B35A1F"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.404 14.922c-.388.19-.916.447-1.286.447-.258 0-.42-.05-.486-.15v.365c0 .076-.017.166-.033.251-.028.155-.054.293.033.293.134 0 .734.422.734.909 0 .324-.244.62-.734.886.324 1.141.628 1.8.912 1.974.228.14.375.055.465-.018l.027-.022c.052-.045.074-.063.074.04 0 .01 0 .019.002.034.03.259.386.603.807.742.284.094.2.166.106.248-.051.045-.106.093-.106.148 0 .1.162.058.486-.125.324.183.487.225.487.125 0-.055-.055-.103-.107-.148-.095-.082-.178-.154.107-.248.42-.14.776-.483.807-.747l.002-.03c0-.102.021-.084.076-.037l.028.023c.087.07.233.155.461.015.284-.175.588-.833.913-1.974-.49-.267-.735-.562-.735-.886 0-.487.6-.909.735-.909.086 0 .06-.137.032-.293a1.467 1.467 0 01-.032-.25v-.367c-.066.1-.229.151-.487.151-.37 0-.897-.258-1.286-.447-.298-.146-.514-.252-.514-.17 0 .112-.08.09-.212.055-.055-.015-.12-.033-.192-.044a.039.039 0 00-.026-.01.88.88 0 00-.057.001.88.88 0 00-.057-.002.039.039 0 00-.026.011c-.072.011-.137.029-.192.044-.132.036-.211.057-.211-.055 0-.082-.216.024-.515.17zm3.774.018c.045.117.045.21 0 .279v-.279z",
      fill: "#FFD129"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M29.918 11.043h-8.889v8.61c0 .845.352 1.177.772 1.571.124.118.255.24.384.384.375.418 1.472.85 3.289 1.297.497 0 1.316-.273 2.457-.817 1.14-.545 1.803-1.23 1.987-2.055v-8.99zm-8.11 9.896c-.419-.405-.57-.7-.57-1.287v-8.395h8.47v8.75c-.174.742-.79 1.372-1.866 1.886-1.095.523-1.883.788-2.345.797-1.76-.434-2.824-.855-3.159-1.228a6.22 6.22 0 00-.315-.32c.006.006-.169-.158-.215-.203z",
      fill: "#000"
    }
  )), /* @__PURE__ */ e.createElement("path", { fill: "#2B409A", d: "M0 0h18v14H0z" }), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "BM_svg__e",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 14
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h18v14H0z" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#BM_svg__e)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-2.006 13l3.961 1.737L18.088 1.89l2.09-2.582-4.236-.58-6.58 5.537-5.297 3.73L-2.005 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-1.463 14.216l2.018 1.009L19.428-.933h-2.833l-18.058 15.15z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.004 13l-3.961 1.737L-.09 1.89-2.18-.693l4.236-.58 6.58 5.537 5.297 3.73L20.003 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.87 13.874l-2.019 1.008-8.036-6.918-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.927 7.004 5.943z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "BM_svg__f",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -2,
      width: 22,
      height: 18,
      fill: "#000"
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M-2-2h22v18H-2z" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.985 0v-1.5h-1.5V0h1.5zm2 0h1.5v-1.5h-1.5V0zm-2 6v1.5h1.5V6h-1.5zM0 6V4.5h-1.5V6H0zm0 2h-1.5v1.5H0V8zm7.985 0h1.5V6.5h-1.5V8zm0 6h-1.5v1.5h1.5V14zm2 0v1.5h1.5V14h-1.5zm0-6V6.5h-1.5V8h1.5zM18 8v1.5h1.5V8H18zm0-2h1.5V4.5H18V6zM9.985 6h-1.5v1.5h1.5V6zm-2-4.5h2v-3h-2v3zm1.5 4.5V0h-3v6h3zM0 7.5h7.985v-3H0v3zm1.5.5V6h-3v2h3zm6.485-1.5H0v3h7.985v-3zm1.5 7.5V8h-3v6h3zm.5-1.5h-2v3h2v-3zM8.485 8v6h3V8h-3zM18 6.5H9.985v3H18v-3zM16.5 6v2h3V6h-3zM9.985 7.5H18v-3H9.985v3zM8.485 0v6h3V0h-3z",
      fill: "#F7FCFF",
      mask: "url(#BM_svg__f)"
    }
  ))))
);
export {
  t as default
};
